// externals
import { SlideOut } from '@interstate/components/SlideOut';
import styled from 'styled-components';

const cellBorder = { border: '0px solid #000' };

// Define a single column template to be used throughout
const colTemplate = '1.2fr 0.85fr 0.85fr 1.1fr';
const keyValTemplate = '2fr 3fr';

const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: colTemplate,
    gridAutoRows: '3rem',
    gridRowGap: '0.5rem',
    alignItems: 'center',
    margin: '0 1rem'
};

const gridPairsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: keyValTemplate,
    gridAutoRows: '1rem',
    gridRowGap: '1rem',
    alignItems: 'center',
    margin: '0 1rem'
};

const titleStyle = {
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'space-between',
    paddingBottom: '1rem',
    padding: '0.5714rem 1rem'
};

const gridHeaderStyle = {
    fontFamily: 'Roboto Flex',
    color: '#6D6D6D',
    textAlign: 'center' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...cellBorder
};

const leftAlignGridHeaderStyle = {
    ...gridHeaderStyle,
    textAlign: 'left' as const,
    justifyContent: 'flex-start'
};

const leftAlignBoldGridHeaderStyle = {
    ...leftAlignGridHeaderStyle,
    fontSize: '1.2rem',
    fontWeight: '700',
    color: '#000000'
};

const firstColumnStyle = {
    fontFamily: 'Roboto Flex',
    color: '#6D6D6D',
    textAlign: 'left' as const,
    display: 'flex',
    alignItems: 'center',
    ...cellBorder
};

const leftAlignColumnStyle = {
    ...firstColumnStyle,
    color: '#000000',
    textAlign: 'left' as const,
    justifyContent: 'flex-start'
};

const rightAlignColumnStyle = {
    ...firstColumnStyle,
    color: '#000000',
    textAlign: 'right' as const,
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center'
};

const visualLineStyle = {
    gridColumn: '1 / -1',
    width: '100%',
    borderTop: '0.05rem solid #000',
    margin: '1.25rem 0'
};

export const RollToWarningOverlay = styled.div`
    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.95);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
    height: 100%;
    z-index: 9999;
`;

const indicatorContainerStyle = {
    width: 20,
    display: 'inline-flex',
    justifyContent: 'center'
};

export {
    firstColumnStyle,
    gridContainerStyle,
    gridHeaderStyle,
    gridPairsContainerStyle,
    leftAlignBoldGridHeaderStyle,
    leftAlignColumnStyle,
    leftAlignGridHeaderStyle,
    rightAlignColumnStyle,
    titleStyle,
    visualLineStyle,
    indicatorContainerStyle
};

export const StyledSlideOut = styled(SlideOut)`
    .MuiDrawer-paper {
        width: 100% !important;
    }

    .ids-SlideOut-content {
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;

        & [id^='roll-to-options-tabs-tabs-id-'] {
            margin-left: 0;
        }

        & #roll-to-options-tabs {
            padding: 0;
            position: sticky !important;
            top: 0;
            z-index: 10;
            background-color: #fff;
        }

        & .roll-to-slideout-content {
            margin-left: 0;
            padding-inline: 0;
        }

        & #roll-to-options-banner-region {
            padding: 0.5714rem 1rem;
        }
    }

    #ids-SlideOut-footer {
        background-color: #f4f4f4;
        border-top: 1px solid #b2b2b2;
        margin-top: auto;
        padding: 0;
        position: sticky !important;
        bottom: 0 !important;
        right: 0 !important;
        width: 100% !important;
        display: flex;
        flex-direction: column;
        justify-content: center;

        & #ids-action-buttons-container {
            background-color: #f4f4f4;
            /* margin-right: 1rem; */
            padding-inline: 1rem;

            justify-content: center;

            & div.ids-action-button-options {
                flex: auto;
                width: 100%;
            }
            & button {
                width: 100%;
            }
        }
    }

    @media screen and (min-width: 679px) {
        .MuiDrawer-paper {
            width: 688px !important;
        }

        .ids-SlideOut-content {
            & #roll-to-options-tabs {
                padding-inline: 1rem;
            }

            & .roll-to-slideout-content {
                padding-inline: 1rem;
            }

            & #roll-to-options-banner-region {
                padding: 0.5714rem 1.1429rem;
            }
        }

        #ids-SlideOut-footer {
            & #ids-action-buttons-container {
                justify-content: end;

                & div.ids-action-button-options {
                    flex: 1;
                    width: auto;
                }
                & button {
                    width: auto;
                }
            }
        }
    }
`;
